import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
 setlang:string;
  constructor( public translate: TranslateService) {
    this.setdefaultlang();
    }
   
    setdefaultlang(){
      this.translate.addLangs(['en', 'fr','hi','ar']);
      this.translate.setDefaultLang('en');
      this.setlang ='en'
    }

    switchLang(lang: string) {
      this.translate.use(lang);
      this.setlang =lang;
      // console.log(lang)
    }
  


}
